import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

const cookieName = 'glints_device_id';

export function getDeviceIDFromCookie() {
  const deviceID = Cookies.get(cookieName);
  if (!deviceID) {
    throw new Error('Device ID not found in cookie');
  }
  return deviceID;
}

export function setDeviceIDToCookie() {
  const deviceID = Cookies.get(cookieName) || uuidv4();
  Cookies.set(cookieName, deviceID);
}
